import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";

import { getUserApi, showUsersByRoleApi } from "../../../../services/Admin/user";

export default function Client(props) {
    const {
        defaultUserClientValueList,
        setDefaultUserClientValueList,
        formik,
        isClientSelect,
        setIsClientSelect,
        setOriginalClient,
        setServices,

        listRegion,
        setListRegion,
        listProvince,
        setListProvince,
        listMunicipality,
        setListMunicipality,
        listComarca,
        setListComarca,
        listCountry,
        setListCountry,

        clientPhone,
        setClientPhone,
        clientEmail,
        setClientEmail,
    } = props

    const [listUserClient, setListUserClient] = useState([])

    const [inputsValue, setInputsValue] = useState({})

    useEffect(() => {
        getClients()
        if (formik.values.idClient) {
            getDataUser(formik.values.idClient)
        }
    }, [])


    // Lista con todos los clientes de la plataforma
    const getClients = async () => {
        showUsersByRoleApi({ roleName: "ROLE_CLIENT" }).then(resp => {
            if (resp.data.status) {
                const temp = resp.data.data.map((doc) => {
                    return {
                        id: doc.id,
                        ...doc,
                    }
                })
                setListUserClient(temp)
            }
        })
    }

    const getDataUser = (id) => {
        getUserApi(id).then(resp => {
            setOriginalClient(resp.data.data)

            setInputsValue({ ...inputsValue, direccion: resp.data.data.info })
            formik.values.direccion = resp.data.data.info
            formik.values.idClient = resp.data.data.id
            formik.values.observacionesCliente = resp.data.data.observaciones

            formik.values.idRegion = null
            formik.values.idMunicipality = null

            setClientPhone(resp.data.data.phone)
            setClientEmail(resp.data.data.email)

            setListRegion(resp.data.data.idRegion)
            setListProvince(resp.data.data.idProvince)
            setListMunicipality(resp.data.data.idMunicipality)
            setListComarca(resp.data.data.idComarca)
            setListCountry(resp.data.data.idCountry)

            // Services
            setServices(resp.data.data.services);
        }).catch(err => {
            console.error(err.response.data?.msg)
        })
    }

    const changeClient = (event, value) => {
        props.chnageClient()
        if (value !== null) {
            formik.values.idClient = value.id
            setDefaultUserClientValueList({
                id: value.id,
                name: value.name,
                surnames: value.surnames,
                email: value.email
            })
            setIsClientSelect(true)
            getDataUser(value.id)
        } else {
            removeClient()
        }
    }

    const removeClient = () => {
        setClientPhone("")
        setClientEmail("")
        setServices([]);
        formik.values.idClient = null
        setDefaultUserClientValueList(null)
        formik.values.idCompany = null
        formik.values.direccion = ""
        formik.values.observacionesCliente = ""
        // Limpiar form
        formik.values.idRegion = null
        setIsClientSelect(false)

        // Limpiar las listas
        setListRegion([])
        setListProvince([])
        setListMunicipality([])
        setListComarca([])
        setListCountry([])
    }

    return (
        <Box border={3} className="p-20 mt-2 box-default">
            <Grid container spacing={3}>
                <Grid item md={12}>
                    <h5 className="p-0 mt-0">Cliente</h5>
                </Grid>
                <Grid item md={12}>
                    <Autocomplete
                        options={listUserClient}
                        value={defaultUserClientValueList}
                        getOptionLabel={(option) => {
                            if (Object.keys(option).length !== 0) {
                                return `${option.name} ${option.surnames} ${option.email}`
                            } else {
                                return ""
                            }
                        }}
                        fullWidth
                        size="small"
                        renderInput={(params) => <TextField
                            {...params}
                            label="* Cliente"
                            variant="outlined"
                            name="idClient"
                            InputLabelProps={{ shrink: true }}

                        />}
                        isOptionEqualToValue={(option, value) => option.id === value.id}
                        onChange={changeClient}
                    />
                    {formik.errors.idClient && (
                        <p className="text-100 text-danger mt-1">
                            {formik.errors.idClient}
                        </p>
                    )}
                </Grid>

                <Grid item md={12}>
                    <div style={{ flex: 1 }}>
                        <FormControl fullWidth size="small" variant="outlined">
                            <InputLabel shrink htmlFor="idCountry">
                                * País
                            </InputLabel>
                            <Select
                                label="* País"
                                name="idCountry"
                                id="idCountry"
                                value={formik.values.idCountry?.id || ""}
                                disabled={!isClientSelect}
                                onChange={e => {
                                    const country = listCountry.find(r => r.id === e.target.value) || null;
                                    formik.setFieldValue("idCountry", country ? Object(country) : {});
                                    formik.setFieldValue("idRegion", null);
                                    formik.setFieldValue("idProvince", null);
                                    formik.setFieldValue("idMunicipality", null);
                                }}
                                displayEmpty
                            >
                                <MenuItem value="">
                                    <em>Seleccione un país</em>
                                </MenuItem>
                                {listCountry.map(country => (
                                    <MenuItem key={country.id} value={country.id}>{country.name}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>
                    <div style={{ display: "flex", gap: 10, marginTop: 20 }}>
                        <div style={{ flex: 1 }}>
                            <FormControl fullWidth size="small" variant="outlined" disabled={!formik.values.idCountry?.id}>
                                <InputLabel shrink htmlFor="idRegion">
                                    * Comunitat
                                </InputLabel>
                                <Select
                                    label="* Comunitat"
                                    name="idRegion"
                                    id="idRegion"
                                    value={formik.values.idRegion?.id || ""}
                                    onChange={e => {
                                        const region = listRegion.find(r => r.id === e.target.value) || null;
                                        formik.setFieldValue("idRegion", region ? Object(region) : {});
                                        formik.setFieldValue("idProvince", null);
                                        formik.setFieldValue("idMunicipality", null);
                                    }}
                                    displayEmpty
                                >
                                    <MenuItem value="">
                                        <em>Seleccione una comunidad</em>
                                    </MenuItem>
                                    {listRegion
                                        .filter(r => formik.values.idCountry?.id ? r.idCountry === formik.values.idCountry.id : true)
                                        .map(region => (
                                        <MenuItem key={region.id} value={region.id}>{region.name}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                        <div style={{ flex: 1 }}>
                            <FormControl fullWidth size="small" variant="outlined" disabled={!formik.values.idRegion?.id}>
                                <InputLabel shrink htmlFor="idProvince">
                                    * Provincia
                                </InputLabel>
                                <Select
                                    label="* Provincia"
                                    name="idProvince"
                                    id="idProvince"
                                    value={formik.values.idProvince?.id || ""}
                                    onChange={e => {
                                        const province = listProvince
                                            .filter(p => formik.values.idRegion?.id ? p.idRegion === formik.values.idRegion.id : true)
                                            .find(p => p.id === e.target.value) || null;

                                        formik.setFieldValue("idProvince", province ? Object(province) : {});
                                        formik.setFieldValue("idMunicipality", null);
                                    }}
                                    displayEmpty
                                >
                                    <MenuItem value="">
                                        <em>Seleccione una provincia</em>
                                    </MenuItem>
                                    {listProvince
                                        .filter(p => formik.values.idRegion?.id ? p.idRegion === formik.values.idRegion.id : true)
                                        .map(province => (
                                            <MenuItem key={province.id} value={province.id}>{province.name}</MenuItem>
                                        ))}
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                    <div style={{ display: "flex", gap: 10, marginTop: 20 }}>
                        <div style={{ flex: 1 }}>
                            <FormControl fullWidth size="small" variant="outlined" disabled={!formik.values.idProvince?.id}>
                                <InputLabel shrink htmlFor="idComarca">
                                    * Comarca
                                </InputLabel>
                                <Select
                                    label="* Población"
                                    name="idComarca"
                                    id="idComarca"
                                    value={formik.values.idComarca?.id || ""}
                                    onChange={e => {
                                        const comarca = listComarca
                                            .filter(m => formik.values.idComarca?.id ? m.idComarca === formik.values.idComarca.id : true)
                                            .find(m => m.id === e.target.value) || null;

                                        // formik.setFieldValue("idComarca", comarca);
                                        formik.setFieldValue("idComarca", comarca ? Object(comarca) : {});
                                    }}
                                    displayEmpty
                                >
                                    <MenuItem value="">
                                        <em>Seleccione una población</em>
                                    </MenuItem>
                                    {listComarca
                                        .filter(m => formik.values.idProvince?.id ? m.idProvince === formik.values.idProvince.id : true)
                                        .map(comarca => (
                                            <MenuItem key={comarca.id} value={comarca.id}>{comarca.name}</MenuItem>
                                        ))}
                                </Select>
                            </FormControl>
                        </div>
                        <div style={{ flex: 1 }}>
                            <FormControl fullWidth size="small" variant="outlined" disabled={!formik.values.idComarca?.id}>
                                <InputLabel shrink htmlFor="idMunicipality">
                                    * Población
                                </InputLabel>
                                <Select
                                    label="* Población"
                                    name="idMunicipality"
                                    id="idMunicipality"
                                    value={formik.values.idMunicipality?.id || ""}
                                    onChange={e => {
                                        const municipio = listMunicipality
                                            .filter(m => formik.values.idProvince?.id ? m.idProvince === formik.values.idProvince.id : true)
                                            .find(m => m.id === e.target.value) || null;

                                        // formik.setFieldValue("idMunicipality", municipio);
                                        formik.setFieldValue("idMunicipality", municipio ? Object(municipio) : {});
                                    }}
                                    displayEmpty
                                >
                                    <MenuItem value="">
                                        <em>Seleccione una población</em>
                                    </MenuItem>
                                    {listMunicipality
                                        .filter(m => formik.values.idComarca?.id ? m.idComarca === formik.values.idComarca.id : true)
                                        .map(municipio => (
                                            <MenuItem key={municipio.id} value={municipio.id}>{municipio.name}</MenuItem>
                                        ))}
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                </Grid>

                <Grid item md={12}>
                    <TextField
                        disabled={!isClientSelect}
                        name="direccion"
                        label="Dirección"
                        multiline
                        rows={2}
                        variant="outlined"
                        fullWidth
                        size="small"
                        value={formik.values.direccion}
                        onChange={formik.handleChange}
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>

                <Grid item md={12}>
                    <TextField
                        disabled={!isClientSelect}
                        name="observacionesCliente"
                        label="Observaciones del cliente"
                        multiline
                        rows={4}
                        variant="outlined"
                        fullWidth
                        size="small"
                        value={formik.values.observacionesCliente}
                        onChange={formik.handleChange}
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>

                <Grid item md={12}>
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "flex-start",
                            gap: 6,
                            alignItems: "flex-start",
                            bgcolor: "#f5f5f5",
                            borderRadius: 1,
                            p: 2,
                            mt: 1,
                        }}
                    >
                        <Box sx={{ minWidth: 180 }}>
                            <span style={{ fontWeight: 600, color: "#333", fontSize: 15 }}>Teléfono</span>
                            <div style={{ marginTop: 4, fontSize: 16, color: clientPhone ? "#222" : "#888", fontWeight: 500 }}>
                                {clientPhone || <em>No disponible</em>}
                            </div>
                        </Box>
                        <Box sx={{ minWidth: 180 }}>
                            <span style={{ fontWeight: 600, color: "#333", fontSize: 15 }}>Email</span>
                            <div style={{ marginTop: 4, fontSize: 16, color: clientEmail ? "#222" : "#888", fontWeight: 500 }}>
                                {clientEmail || <em>No disponible</em>}
                            </div>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    )
}
